/**
 * Capitalizes the first letter of the input string and lowercases the rest.
 * @param str The input string to be transformed.
 * @returns transformed string with the 1st letter capitalized & the rest lowercased.
 */
export const capitalizeFirstLowerRest = (str: string) => {
  if (str === null || str === undefined || str.length === 0) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * Converts the input string to title case (first letter of each word capitalized).
 * @param str The input string to be transformed.
 * @returns The transformed string in title case.
 */
export const titleCase = (str: string) => {
  if (str === null || str === undefined || str.length === 0) return '';
  const words = str.split(/ /g);
  const cleanWords = words.map(word => capitalizeFirstLowerRest(word));
  return cleanWords.join(' ');
};
